import { reset } from "@amplitude/analytics-browser";
import { deleteMessages, toggleWidget } from "react-chat-widget";
import {
  accessTokenCookieName,
  refreshTokenCookieName,
} from "../../common/config";
import { storage } from "../../common/helpers/storage";
import { loginCookies } from "../../shared/utils/auth";
import { appStore } from "../../store";
import { LOG_OUT } from "./actions-types";

export const setLogOut = () => ({
  type: LOG_OUT,
});

export const logout = () => (dispatch) => {
  const { connection, channel, chatOpen } = appStore.getState().chatReducer;
  const { profile } = appStore.getState();

  if (connection) {
    deleteMessages(1);
    connection.send(
      "DisconnectToChannel",
      channel.channelId.toString(),
      profile.participantProfileId.toString()
    );
    if (chatOpen) {
      toggleWidget();
    }
    appStore.dispatch({
      type: "RESET_CHAT",
    });
  }

  reset();

  storage.delete("widget");
  loginCookies.remove(accessTokenCookieName);
  loginCookies.remove(refreshTokenCookieName);

  dispatch(setLogOut());

  window.location.replace("/");
};
